import React,{ Component } from "react";
import {connect} from "react-redux";
import { getSystemInfo, getLicenses, addLicense, deleteLicense,setLicensePageInfo} from "../../actions/actionSystemInfo";
import { Row, Col, Table, Button, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import DateTimePicker from 'react-datetime-picker';
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { Alert } from 'reactstrap';
import LoadingSpinner from "../../components/LoadingSpinner";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
];

class ViewSystemInfo extends Component{
    constructor(props){
        super(props);

        this.state = {
            addLicenseModal: false,
            deleteLicenseModal: false,
            license_key: '',
            licenseId: null,
            visible: true,
        };

        this.openLicenseAddModal = this.openLicenseAddModal.bind(this);
        this.toggleLicense = this.toggleLicense.bind(this);
        this.addLicense = this.addLicense.bind(this);
        this.handleAddLicenseSuccess = this.handleAddLicenseSuccess.bind(this);
        this.handleAddLicenseError = this.handleAddLicenseError.bind(this);
        this.handleLicenseChange = this.handleLicenseChange.bind(this);
        this.deleteLicenseConfirm = this.deleteLicenseConfirm.bind(this);
        this.deleteLicense = this.deleteLicense.bind(this);
        this.handleDeleteLicenseSuccess = this.handleDeleteLicenseSuccess.bind(this);
        this.handleDeleteLicenseError = this.handleDeleteLicenseError.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }
  
    componentDidMount(){
        this.props.getSystemInfo();
        this.props.getLicenses();
    }

    openLicenseAddModal(){
        this.setState({addLicenseModal: !this.state.addLicenseModal});
    }

    toggleLicense(){
        this.setState({addLicenseModal: !this.state.addLicenseModal});
    }

    addLicense(){
        let data = {};
        data.license_key = this.state.license_key;
        this.props.addLicense(data).then(() => this.handleAddLicenseSuccess()).catch(() => this.handleAddLicenseError());
    }

    handleLicenseChange(event) {
        this.setState({license_key: event.target.value});
    }

    handleAddLicenseSuccess(){
        const {system_info} = this.props;
        if(system_info.addLicenseError){
            NotificationManager.error(system_info.addLicenseError,"Add License", 6000);
        }
        else{
            NotificationManager.success("Added License Successfully","Add License", 3000);
            this.setState({addLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleAddLicenseError(){
        const {system_info} = this.props;
        if(system_info.addLicenseError){
            NotificationManager.error(system_info.addLicenseError,"Add License", 6000);
        }
        else {
            NotificationManager.error("Error adding license","Add License", 6000);
            this.setState({addLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleDeleteLicenseSuccess(){
        const {system_info} = this.props;
        if(system_info.deleteLicenseError){
            NotificationManager.error(system_info.deleteLicenseError,"Delete License", 6000);
        }
        else{
            NotificationManager.success("Deleted License Successfully","Delete  License", 3000);
            this.setState({deleteLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    handleDeleteLicenseError(){
        const {system_info} = this.props;
        if(system_info.deleteicenseError){
            NotificationManager.error(system_info.deleteLicenseError,"Delete License", 6000);
        }
        else {
            NotificationManager.error("Error deleting license","Delete License", 6000);
            this.setState({deleteLicenseModal: false});
            this.props.getLicenses();
            this.props.getSystemInfo();
        }
    }

    deleteLicenseConfirm(licenseId){
        this.setState(
            {
                deleteLicenseModal: !this.state.deleteLicenseModal,
                licenseId: licenseId
            });
    }

    deleteLicense(){
        let data = {};
        data.licenseId = this.state.licenseId;
        this.props.deleteLicense(data).then(() => this.handleDeleteLicenseSuccess()).
            catch(() => this.handleDeleteLicenseError());
    }

    onDismiss() {
        this.setState({ visible: false });
    }

    render(){
        if (this.props.getSystemInfoLoading || this.props.getLicensesLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        
        const { system_info } = this.props;

        const tableColumns = [
            {
                type: "date",
                accessor: "expiration",
                name: "Expiration",
                filterable: true,
                sortable: true,
                cell: (data) => (
                    <div className={data.original.is_verified ? "" : "license_not_ok"} >
                        {moment(data.original.expiration).format("L h:mm A")}
                    </div>
                ),
            },
            {
                type: "text",
                accessor: "sku",
                name: "SKU",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "license_type",
                name: "Type",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "limit",
                name: "Limit",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "issued_to",
                name: "Issued To",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "delete":
                    this.deleteLicenseConfirm(item.license_id);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                            <strong>System Info</strong></div>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div className="profile-table">
                                            {system_info.system_info?
                                                <React.Fragment>
                                                    {system_info.system_info.update.status &&
                                                        system_info.system_info.update.update_available &&
                                                            <Alert color="info" isOpen={this.state.visible} toggle={this.onDismiss}>
                                                                <h4>Update Available</h4>
                                                                Update Version: {system_info.system_info.update.status.latest_version}
                                                                <hr />
                                                                <a href={system_info.system_info.update.status.release_notes_url}>Release Notes</a><br/>
                                                                {system_info.system_info.update.status.alert && system_info.system_info.update.status.alert}
                                                            </Alert>}
                                                    <Table >
                                                        <tbody>
                                                            <tr><td> <h4>Database Host</h4></td><td>{system_info.system_info.db.host ? system_info.system_info.db.host : "-"}</td></tr>
                                                            <tr><td><h4>Database Version</h4></td><td>{system_info.system_info.db.alembic_version ? system_info.system_info.db.alembic_version : "-"}</td></tr>
                                                            <tr><td><h4>API Server ID</h4></td><td>{system_info.system_info.api.server_id ? system_info.system_info.api.server_id : "-"}</td></tr>
                                                            <tr><td><h4>API Server Host</h4></td><td>{system_info.system_info.api.server_hostname ? system_info.system_info.api.server_hostname : "-"}</td></tr>
                                                            <tr><td><h4>API Server Build</h4></td><td>{system_info.system_info.api.build_id ? system_info.system_info.api.build_id : "-"}</td></tr>
                                                            <tr><td><h4>API Server Zone</h4></td><td>{system_info.system_info.api.zone_name ? system_info.system_info.api.zone_name : "-"}</td></tr>
                                                            <tr><td><h4>Installation ID</h4></td><td>{system_info.system_info.db.installation_id ? system_info.system_info.db.installation_id : "-"}</td></tr>
                                                            <tr><td><h4>License Status</h4></td><td className=
                                                            {system_info.system_info.license.status.licensed ? "license_ok" : "license_not_ok"}
                                                            >{system_info.system_info.license.status.licensed ? "OK" : "Unlicensed"}</td></tr>
                                                            <tr><td><h4>License Type</h4></td><td>{system_info.system_info.license.status.license_type ? system_info.system_info.license.status.license_type : "-"}</td></tr>
                                                            <tr><td><h4>License Limit</h4></td><td>{system_info.system_info.license.status.limit ? system_info.system_info.license.status.limit : "-"}</td></tr>
                                                            <tr><td><h4>License Limit Remaining</h4></td><td>{system_info.system_info.license.status.limit_remaining ? system_info.system_info.license.status.limit_remaining : "-"}</td></tr>
                                                        </tbody>
                                                    </Table>
                                                </React.Fragment>:" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-exclamation-circle"></i> <strong>Licenses</strong> </div>
                                <button className="pull-right adduser-btn" size="sm" color="dark"
                                        onClick={this.openLicenseAddModal}> 
                                         <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add License</button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="system-info"
                                    data={system_info.licenses}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>

                        <Modal isOpen={this.state.addLicenseModal} toggle={this.toggleLicense}
                               className="user-modal">
                            <ModalHeader toggle={this.toggleLicense}>Add License</ModalHeader>
                            <ModalBody>
                                <Form>
                                    <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label for="exampleText">Enter License or Activation Key</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input type="textarea" name="text" id="exampleText" onChange={this.handleLicenseChange} rows="10" />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                </Form>

                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.toggleLicense} 
                                className="cancel-button"
                                size="sm" color="basic">Cancel</Button>
                                <Button onClick={this.addLicense} 
                                className="submit-button"
                                size="sm" color="primary">Add</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.deleteLicenseModal} toggle={this.deleteLicenseConfirm} className="user-modal">
                            <ModalHeader toggle={this.deleteLicenseConfirm}>Are you sure you want to delete this license?
                            </ModalHeader>
                            <ModalFooter>
                                <Button onClick={this.deleteLicenseConfirm} 
                                className="cancel-button"
                                size="sm" color="basic"> Close</Button>
                                <Button onClick={this.deleteLicense} 
                                className="delete-button"
                                size="sm" color="danger">Delete</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal className="datetimeModal user-modal" zIndex={999999} isOpen={this.state.isShowPicker} toggle={this.togglePickerModal} >
                            <ModalHeader toggle={this.togglePickerModal}>
                                Select Date and Time
                            </ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col>
                                        <div className="date-outer">
                                            <h6 className="title-label">Start Date</h6>
                                            <DateTimePicker
                                                clearIcon={null}
                                                required={true}
                                                onChange={this.changeStartDate}
                                                value={this.state.startDate}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                    <div className="date-outer">
                                    <h6 className="title-label">End Date</h6>
                                        <DateTimePicker
                                            clearIcon={null}
                                            required={true}
                                            onChange={this.changeEndDate}
                                            value={this.state.endDate}
                                        />
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <button size="sm"
                                    color="basic"  
                                    className="cancel-bttn"  
                                    onClick={()=>{
                                        this.setState({
                                            endDate: new Date(),
                                            startDate: new Date(Date.now() - 60000 * 60),
                                            isShowPicker : false
                                        })
                                    }} 
                                >
                                Cancel
                                </button>
                                <button 
                                    className="update-bttn"
                                    onClick={()=>this.filterDateData(system_info.licenses)}
                                    size="sm"  
                                    color="primary" 
                                >
                                    Update
                                </button>
                            </ModalFooter>
                        </Modal>
                    </Col>
                </Row>
            </div>
        );}
}

ViewSystemInfo.propTypes = {
    getSystemInfo: Proptypes.func.isRequired,
    system_info: Proptypes.object,
    licenses: Proptypes.object,
    addLicense:  Proptypes.func.isRequired,
    getLicenses: Proptypes.func.isRequired,
    addLicenseError: Proptypes.func,
    deleteLicense: Proptypes.func.isRequired,
    getSystemInfoLoading: Proptypes.bool
};

export default connect(state =>
    ({
        system_info: state.system_info || null,
        addLicenseError: state.system_info.addLicenseError || null,
        getSystemInfoLoading: state.system_info.getSystemInfoLoading || null,
        getLicensesLoading: state.system_info.getLicensesLoading || null,
        pages : {pageSize : state.system_info.pageSize, pageNo : state.system_info.pageNo},
    }),
dispatch =>
    ({
        getSystemInfo: () => dispatch(getSystemInfo()),
        getLicenses: () => dispatch(getLicenses()),
        addLicense: (data) => dispatch(addLicense(data)),
        deleteLicense: (data) => dispatch(deleteLicense(data)),
        setPageInfo : (data)=> dispatch(setLicensePageInfo(data)),
    }))(ViewSystemInfo);



// WEBPACK FOOTER //
// ./src/views/SystemInfo/SystemInfo.js